// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseModel } from './caseModel.js';
import type { SearchWorkflowsResponseModel } from './searchWorkflowsResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SearchCasesResponseModel {
    'intakeCase': CaseModel | null;
    'workflows': Array<SearchWorkflowsResponseModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SearchCasesResponseModel>> = [
        {
            "name":     "intakeCase",
            "baseName": "intakeCase",
            "type":     "CaseModel"
        },
        {
            "name":     "workflows",
            "baseName": "workflows",
            "type":     "Array<SearchWorkflowsResponseModel>"
        },
    ];

    static getAttributeTypeMap() {
        return SearchCasesResponseModel.attributeTypeMap;
    }
}
